<template>
  <div class="outer">
    <div class="header">
      <div class="title1">Picking a PRNG can be <em>hard</em>...</div>
      <div class="title2">...but we can help!</div>
    </div>
    <div class="container">
      <MenuCard icon="quiz" route="quiz" short="Find your PRNG">
        Answer a series of questions about your use case to get paired with the pseudorandom number generator that best fits your needs.
      </MenuCard>
      <MenuCard icon="table_chart" route="table" short="View our Database">
        A collection of individual algorithms with specific information about performance, implementation, and statistcal test performance on the TestU01 suite.
      </MenuCard>
      <MenuCard icon="account_tree" route="tree" short="View the Tree">
        We used an ID3 decision tree algorithm to help narrow down the algorithm selection in as few questions as possible.
        The GraphViz output of that tree is available here.
      </MenuCard>
      <MenuCard icon="casino" route="random" short="View a random PRNG">
        Learn about a random algorithm from our database.  Feeling lucky?
      </MenuCard>

    </div>
  </div>
</template>

<script>
import MenuCard from "@/components/MenuCard";
export default {
  name: "Main",
  components: {MenuCard}
}
</script>

<style scoped>
.outer {
  display: flex;
  flex-wrap: wrap;
  max-width: 1000px;
  align-content: space-around;
  justify-content: space-around;
}
.header{
  width: 400px;
  height: 200px;
  justify-items: center;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px dashed black;
}

.title1 {
  font-size: 45px;
  font-weight: bolder;
}

.title2 {
  margin-top: 20px;
  font-size: 20px;
}

.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: space-between;
  max-width: 900px;
}
</style>